export default "__VITE_ASSET__D1B2sNVg__"